import { SvgIcon, SvgIconProps } from "@mui/material";

export const DragHandleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9.497 18.005c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M14.497 18.005c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M9.497 12.003c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M14.497 12.003c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M9.497 6c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5M14.497 6c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5"
      />
    </svg>
  </SvgIcon>
);
